import React from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/sections/Hero";
import { Packages } from "@/components/sections/Packages";
import { StudentWins } from "@/components/sections/StudentWins";
import { ServiceAreas } from "@/components/sections/ServiceAreas";
import { Testimonials } from "@/components/sections/Testimonials";
import { BookingPolicies } from "@/components/sections/BookingPolicies";
import { FAQ } from "@/components/sections/FAQ";
import { FinalCTA } from "@/components/sections/FinalCTA";
import { Footer } from "@/components/sections/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="min-h-screen bg-maple-cream">
      <Header />
      <Hero />
      <StudentWins />
      <Testimonials />
      <Packages />
      <BookingPolicies />
      <FAQ />
      <ServiceAreas />
      <FinalCTA />
      <Footer />
      <FloatingWhatsApp />
    </main>
  );
}
